var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClient = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 18,
  viewBox: "0 0 16 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15 17V15.2222C15 14.2792 14.6313 13.3748 13.9749 12.708C13.3185 12.0412 12.4283 11.6666 11.5 11.6666H4.5C3.57174 11.6666 2.6815 12.0412 2.02513 12.708C1.36875 13.3748 1 14.2792 1 15.2222V17",
  stroke: "#AFB6BE",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 8.11119C9.933 8.11119 11.5 6.5193 11.5 4.5556C11.5 2.59189 9.933 1 8 1C6.067 1 4.5 2.59189 4.5 4.5556C4.5 6.5193 6.067 8.11119 8 8.11119Z",
  stroke: "#AFB6BE",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgClient;